module.exports = ".ponteiro{\r\n    cursor: pointer;\r\n}"